import addError from '../../../utils/error.jsx';

export function request(data) {
    return {
        type: 'EVENTS_CREATE_REQUEST',
        ...data
    };
}

export function error(errors) {
    return {
        type: 'EVENTS_CREATE_ERROR',
        errors
    };
}

export function finish(event) {
    return {
        type: 'EVENTS_CREATE_FINISH',
        event
    };
}
